import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  onAuthStateChanged as _onAuthStateChanged,
  getRedirectResult,
} from 'firebase/auth';
import { firebaseAuth } from './config';

export function onAuthStateChanged(callback) {
  return _onAuthStateChanged(firebaseAuth, callback);
}

export { firebaseAuth, getRedirectResult };

export async function signInWithGoogle() {
  const provider = new GoogleAuthProvider();

  try {
    const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : 'SSR or undefined navigator';

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    if (isMobile) {
      try {
        await signInWithRedirect(firebaseAuth, provider);
        return null;
      } catch (redirectError) {
        throw redirectError;
      }
    } else {
      try {
        const result = await signInWithPopup(firebaseAuth, provider);
        if (!result || !result.user) {
          throw new Error('Google sign in via popup failed - No user in result');
        }
        return result.user;
      } catch (popupError) {
        throw popupError;
      }
    }
  } catch (error) {
    throw error;
  }
}

export async function signOutWithGoogle() {
  try {
    await firebaseAuth.signOut();
  } catch (error) {
    console.error('Error signing out with Google', error);
  }
} 